import h from '../../../helpers/common';
import { bgImgURLsType } from './interface';

const settings = {
    autoplay: false,
    loop: false,
    slidesPerGroup: 1,
    slidesPerView: 2,
    pagination: {
        el: '.paging',
        clickable: true,
    },
};

export function getSwiperSettings(language: string, slidesPerView: number) {
    return {
        dir: language == 'ar' ? 'rtl' : 'ltr',
        slidesPerView: 2,
        breakpoints: {
            560: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: slidesPerView,
            },
            924: {
                slidesPerView: slidesPerView,
            },
            1212: {
                slidesPerView: slidesPerView,
            },
        },
        ...settings,
    };
}

export function getBackgroundImageURL(backgroundImageUrls: bgImgURLsType[]) {
    const tvUrlObj = backgroundImageUrls.find((item: bgImgURLsType) => item.key.toLowerCase() === 'tv');
    const tabletUrlObj = backgroundImageUrls.find((item: bgImgURLsType) => item.key.toLowerCase() === 'tablet');

    const img = tvUrlObj ? tvUrlObj.url : tabletUrlObj ? tabletUrlObj.url : null;
    return h.getImagizerUrl(img, 400);
}

export function getTransformedCategories(categories: any) {
    return categories.map((el) => ({
        id: el.id,
        title: el.assetTitleKey,
        image: getBackgroundImageURL(el.backgroundImageUrls),
        ...el,
    }));
}
